export default {
  DESKTOP: 1200,
  LAPTOPH: 1024,
  LAPTOP: 992,
  TABLET: 768,
  PHONE: 376,
};
